(function () {
  'use strict';
  if (window.__winksProductEducation) return;
  window.__winksProductEducation = true;

  var mounted = new WeakMap();
  function roots(scope) {
    var result = Array.from(scope.querySelectorAll('.winks-information-tabs'));
    if (scope.matches && scope.matches('.winks-information-tabs')) result.unshift(scope);
    return result;
  }
  function mount(root) {
    if (mounted.has(root)) return;
    var nav = root.querySelector('.winks-information-tabs__nav');
    if (!nav) return;
    var tabs = Array.from(nav.querySelectorAll('[data-winks-tab]'));
    var panels = tabs.map(function (tab) {
      return root.querySelector('[data-winks-panel="' + tab.dataset.winksTab + '"]');
    });
    // Incomplete merchant markup retains the readable, stacked fallback.
    if (!tabs.length || panels.some(function (panel) { return !panel || !panel.id; })) return;
    var controller = new AbortController();
    mounted.set(root, controller);
    nav.setAttribute('role', 'tablist');
    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    }
    tabs.forEach(function (tab, index) {
      tab.id = panels[index].id + '-tab';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', function () { select(index, false); }, { signal: controller.signal });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
      }, { signal: controller.signal });
    });
    select(0, false);
    nav.hidden = false;
  }
  var ingredientMounts = new Map();
  function mountIngredients(scope) {
    var entries = Array.from(scope.querySelectorAll('.winks-ingred--explorer'));
    entries.forEach(function (entry) {
      if (ingredientMounts.has(entry)) return;
      var summary = entry.querySelector('summary');
      var evidence = entry.querySelector('.winks-ingred__evidence');
      if (!summary || !evidence || typeof HTMLDialogElement === 'undefined') return;
      var controller = new AbortController();
      var dialog = document.createElement('dialog');
      dialog.className = 'winks-ingredient-dialog';
      dialog.setAttribute('aria-label', summary.getAttribute('aria-label') || 'Ingredient details');
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'winks-ingredient-dialog__close';
      close.setAttribute('aria-label', 'Close ingredient details');
      close.textContent = '×';
      var content = evidence.cloneNode(true);
      var heading = content.querySelector('.winks-ingred__detail-title');
      if (heading) heading.tabIndex = -1;
      dialog.append(close, content);
      document.body.appendChild(dialog);
      summary.setAttribute('aria-haspopup', 'dialog');
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        dialog.showModal();
        // Touch/pointer users begin at the ingredient name, not a boxed close control.
        // Keyboard and assistive-technology activation retain visible close-button focus.
        if (event.detail > 0 && heading) heading.focus({ preventScroll: true });
        else close.focus();
      }, { signal: controller.signal });
      close.addEventListener('click', function () { dialog.close(); }, { signal: controller.signal });
      dialog.addEventListener('close', function () { summary.focus(); }, { signal: controller.signal });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, { signal: controller.signal });
      ingredientMounts.set(entry, { controller: controller, dialog: dialog });
    });
  }
  function init(scope) { roots(scope).forEach(mount); mountIngredients(scope); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    ingredientMounts.forEach(function (value, entry) {
      if (!event.target.contains(entry)) return;
      value.controller.abort(); value.dialog.remove(); ingredientMounts.delete(entry);
    });
    roots(event.target).forEach(function (root) {
      var controller = mounted.get(root);
      if (controller) controller.abort();
      mounted.delete(root);
    });
  });
}());
